import polpoApi from '@/api/polpoApi';

export default {
  save: async (listItem) => polpoApi.post('lists/list-items', listItem),
  update: async (listItem, copyToLists) => polpoApi.putCopy('lists/list-items', { listItem, copyToLists }),
  delete: async (listItem) => polpoApi.delete('lists/list-items', listItem),
  swapPosition: async (listItemIdA, listItemIdB, listId) => polpoApi.post('lists/list-items/swap', { listItemIdA, listItemIdB, listId }),
  moveItem: async (listItemId, listId, newPosition) => polpoApi.post('lists/list-items/move', { listItemId, listId, newPosition }),
};
